import { create } from 'zustand';
import { QuestionnaireItem } from 'types';

type QuestionnaireState = {
  questionData: QuestionnaireItem | undefined;
};

type QuestionnaireActions = {
  setQuestionData: (data: QuestionnaireItem | undefined) => void;
};

const initialState: QuestionnaireState = {
  questionData: undefined,
};

export const useQuestionnaireStore = create<
  QuestionnaireState & QuestionnaireActions
>((set) => ({
  ...initialState,
  setQuestionData: (data) => set({ questionData: data }),
}));
